import React, { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { createAnnonce } from "../../actions/annonce.action";
import { MdConstruction } from "react-icons/md";
import { toast, ToastContainer } from "react-toastify";
import PaiementModal from "./AnnoncesInformations";
import { CATEGORIES } from "../categorie.constant";

const ArtisanatForm = ({ utilisateurId }) => {
  const ARTISANAT_CATEGORIE_ID = CATEGORIES.find(
    (cat) => cat.label === "Artisanat"
  )?.id;

  const dispatch = useDispatch();

  const fileInputRef = useRef(null);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    setModalIsOpen(true);
  }, []);

  const [formData, setFormData] = useState({
    titre: "",
    description: "",
    prix: "",
    typeArt: "",
    ville: "",
    images: [],
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      return updated;
    });
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, images: e.target.files }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    const dataToSend = new FormData();
    dataToSend.append("categorieId", ARTISANAT_CATEGORIE_ID);
    dataToSend.append("utilisateur", utilisateurId);
    Object.keys(formData).forEach((key) => {
      if (key === "images") {
        for (let i = 0; i < formData.images.length; i++) {
          dataToSend.append("images", formData.images[i]);
        }
      } else {
        dataToSend.append(key, formData[key]);
      }
    });

    try {
      const response = await dispatch(createAnnonce(dataToSend));

      if (
        response &&
        typeof response === "object" &&
        Object.keys(response.errors || {}).length > 0
      ) {
        console.log("Erreurs reçues :", response.errors);
        setErrors(response.errors);
      } else {
        setFormData({
          titre: "",
          description: "",
          prix: "",
          typeArt: "",
          ville: "",
          images: [],
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }

        setErrors({});
        toast.success(
          "Félicitations, votre annonce a bien été créée ! Elle sera soumise à la validation de l'administrateur."
        );
      }
    } catch (err) {
      console.error("Erreur lors de la soumission du formulaire :", err);
    }
  };

  return (
    <>
      <form className="AnnonceForm" onSubmit={handleSubmit}>
        <MdConstruction />

        <h2>Créer une annonce pour faire une rencontre :</h2>

        {errors.titre && (
          <span className="error">Votre annonce doit avoir un titre</span>
        )}
        <input
          type="text"
          name="titre"
          placeholder="Titre"
          onChange={handleChange}
          value={formData.titre}
        />
        {errors.description && (
          <span className="error">
            Veuillez donner une description pour votre annonce
          </span>
        )}
        <textarea
          name="description"
          placeholder="Description"
          onChange={handleChange}
          value={formData.description}
        />
        <select name="typeArt" onChange={handleChange} value={formData.typeArt}>
          <option value="">type d'artisanat</option>
          <option value="Couturier">Couturier</option>
          <option value="Climatiseur">Climatiseur</option>
          <option value="Plombier">Plombier</option>
          <option value="Electricien">Electricien</option>
          <option value="Maçon">Maçon</option>
          <option value="Carreleur">Carreleur</option>
          <option value="Ferronnier">Ferronnier</option>
          <option value="Peintre">Peintre</option>
          <option value="Menuisier">Menuisier</option>
          <option value="Fabriquant de fenêtres">Fabriquant de fenêtre</option>
        </select>

        <input
          type="text"
          name="ville"
          placeholder="Localisation"
          onChange={handleChange}
          value={formData.ville}
        />

        <button className="button" type="submit">
          Créer l'annonce
        </button>

        <span>Prix de l'annonce : 1000 Francs CFA</span>
        <span>Paiement par Orange Money au 07-04-64-27-18</span>
      </form>
      <PaiementModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
      />
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
};

export default ArtisanatForm;
